import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import { useNavigate } from 'react-router-dom';
import Avatar from '../components/Avatar';

const prefixes = ['marble', 'beam', 'bauhaus'] as const;

export default function Profile() {
  const [firstname, setFirstname] = useState('');
  const [lastname, setLastname] = useState('');
  const [avatar, setAvatar] = useState('');
  const [error, setError] = useState('');
  const [user, setUser] = useState<{ id: string } | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadProfile();
  }, []);

  const verifyForm = () => {
    if (!firstname) {
      setError('Un prénom est requis');
      return false;
    }
    if (!lastname) {
      setError('Un nom est requis');
      return false;
    }
    setError('');
    return true;
  };

  const loadProfile = async () => {
    const {
      data: { user },
      error: userError,
    } = await supabase.auth.getUser();

    if (userError || !user) {
      setError('Utilisateur non connecté');
      return;
    }

    setUser(user);

    var storage = sessionStorage.getItem('userProfile');
    let userProfile = null;
    if (storage !== null) {
      userProfile = JSON.parse(storage);
    }

    if (!userProfile) {
      const { data, error } = await supabase
        .from('profiles')
        .select('*')
        .eq('id', user.id)
        .single();

      if (error) {
        // profil pas trouvé ou autre erreur : pas grave, utilisateur peut créer
        return;
      } else {
        userProfile = data;
      }
    }

    if (userProfile) {
      setFirstname(userProfile.firstname);
      setLastname(userProfile.lastname);
      setAvatar(userProfile.avatar);
    }
  };

  const saveProfile = async () => {
    if (!verifyForm() || !user) return;

    const newData = { id: user.id, firstname, lastname, avatar };

    const { error } = await supabase
      .from('profiles')
      .upsert(newData);

    if (error) {
      setError(error.message);
    } else {
      sessionStorage.setItem('userProfile', JSON.stringify(newData));
      setError('');
    }
  };

  const randomAvatar = () => {
    const prefix = prefixes[Math.floor(Math.random() * prefixes.length)];

    let digits = '';
    for (let i = 0; i < 12; i++) {
      digits += Math.floor(Math.random() * 10);
    }

    const newAvatar = `${prefix}-${digits}`;
    setAvatar(newAvatar);
  };

  return (
    <div>
      <h2>Profil</h2>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {!user && 
        <p>
            Chargement du profil
        </p>
      }
      {user && 
      <div>
        <input
          value={firstname}
          onChange={(e) => setFirstname(e.target.value)}
          placeholder="Prénom"
        />
        <input
          value={lastname}
          onChange={(e) => setLastname(e.target.value)}
          placeholder="Nom"
        />
        <div>
          <Avatar avatar={avatar} />
          <button onClick={randomAvatar}>Regénérer</button>
        </div>
        <button onClick={saveProfile}>Valider</button>
        <button onClick={() => navigate('/dispo')}>Dispo</button>
      </div>
      }
    </div>
  );
}
